module.exports = __webpack_public_path__ + "static/media/Celebrity.e3fe07b4.svg";